/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import { Action, ActionType    } from '@/models/action';
import { Logger                } from '@/util/logger';
import { SearchMetadata        } from '@/screens/ide/search.metadata';
import { WindowService         } from "@/services/window.service";

/**
 *
 * @class WindowSearchAction
 *
 * @brief ensure search window is open
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class WindowSearchAction extends Action {

  private      windows: WindowService = null;

  constructor(options: any = null) {

    super({
      key:   'window.search',
      type:  ActionType.Window_Search,
      label: 'Search',
      icon:  '<i class="fas fa-search"></i>',
      tip:   'Ensure the search window is open'
    });

    this.windows  = this.injector().get(WindowService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[WindowSearchAction] executing...');

    this.windows.launchWindow(new SearchMetadata());

    return true;
  }
}
